import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PELanguagesCardActions = {
  initPeLanguagesCard: ({ commit }, index) => {
    commit('setPeLanguagesCardLock', { index, lock: true })
  },
  peLanguagesCardCreate: async ({ commit, getters }, { section }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        learned_languages: {
          party_id: party.id,
          language_id: section.language_id,
          primary: section.primary,
          reading: section.reading,
          writing: section.writing,
          speaking: section.speaking,
        },
      }).
      then(({ data }) => {
        commit('setPeLanguagesCardLock', { index: 'new', lock: true })
        commit('setPeLanguagesCardLock', { index: data.id, lock: true })
        commit('pePatchCharacteristicNew', {
          characteristic: 'learned_languages',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peLanguagesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/learned_languages/${section.id}`).
      then(({ data }) => {
        commit('setPeLanguagesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'learned_languages',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peLanguagesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        learned_languages: {
          party_id: party.id,
          language_id: section.language_id,
          primary: section.primary,
          reading: section.reading,
          writing: section.writing,
          speaking: section.speaking,
        },
        id,
      }).
      then(({ data }) => {
        commit('setPeLanguagesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'learned_languages',
          value: data,
        })
      }).
      catch(handleError)
  },
  peLanguagesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          learned_languages: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const learnedLanguages = data.learned_languages

        commit('setPeLanguagesCardLock', { index, lock: true })
        commit('pePatchParty', {
          learned_languages: learnedLanguages || [],
        })
      }).
      catch(handleError)
  },
  peLanguagesCardAddSection: ({ commit }) => {
    commit('setPeLanguagesCardLock', { index: 'new', lock: false })
    commit('addPeLanguagesCardSection', {
      id: null,
      language_id: null,
      primary: null,
      reading: null,
      writing: null,
      speaking: null,
    })
  },
  peLanguagesCardRefreshAll: async ({ commit, getters }) => {
    const party = getters.peParty

    return axiosRequest.
      get('/party_characteristics', {
        params: {
          type: 'learned_languages',
          party_id: party.id,
        },
      }).
      then(({ data }) => {
        const learnedLanguages = data.learned_languages || []

        commit('pePatchParty', {
          learned_languages: learnedLanguages,
        })
      }).
      catch(handleError)
  },
}

export const PELanguagesCardMutations = {
  setPeLanguagesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.LanguagesCard) Vue.set(state.partyEdit.partySections, 'LanguagesCard', {})
    Vue.set(state.partyEdit.partySections.LanguagesCard, index, lock)
  },
  addPeLanguagesCardSection: (state, section) => {
    state.partyEdit.party.learned_languages.push(section)
  },
  peLanguagesCardCreateUndo: state => {
    state.partyEdit.party.learned_languages.pop()
    Vue.set(state.partyEdit.partySections.LanguagesCard, 'new', true)
  },
}

export const PELanguagesCardGetters = {
  peLanguagesCardLock: state => index => state.partyEdit.partySections.LanguagesCard[index],
  peLanguagesCardHasNewSection: (_, getters) => !!getters.
    peParty.
    learned_languages?.
    find(language => language.id === null),
}
